//@vendor
const React = require("react")
const Immutable = require('immutable');
//@components
const { OKButton } = require('components/commons/OKButton/OKButton');
//@constants
const {
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_TYPE_ONE_TWO_THREE,
    ACCOUNT_TYPE_OPERATIVE,
    ACCOUNT_TYPE_PAYROLL,
    ACCOUNT_NEW_PRODUCT
} = require('constants/index');
const paymentDayTypes = require('../loansConstants/paymentDayType');
// @utilities
const { PAGE_LOANS_MORTGAGES, PAGE_CONTRACT_ARES_LOAN } = require('utilities/tagging');


const {
    payrollLoanErrorDocument: { NOM_VL, IRPF100 },
    payrollLoanRecordStatus: { requestStatus: { APORTAR_DOC, ERROR_DOCUMENTACION, KOxDTI, KOxDTI2 } },
    retailLoanCommons: { ADDRESS_DELIVERY },
    payrollLoanJobTypeKeys: {
        PENSIONER_DRAGO_OPTION_KEY,
        RENTER_DRAGO_OPTION_KEY,
        RETIRED_DRAGO_OPTION_KEY,
        STUDENT_DRAGO_OPTION_KEY,
        UNEMPLOYED_DRAGO_OPTION_KEY,
    },
    retailLoanDoTaggin,
} = require('../loansConstants/index');
const { openPDFViewer } = require('utilities/contactCenter/pdfViewer');
const BrowserUtils = require('utilities/browserUtils');

//@utilities
const { getLastNChars } = require('utilities/stringHelper');

// @core
const { formatText } = require('core/i18n').i18n;

const getFilteredAccountIndexes = immAccounts => {
    return immAccounts.get('byOrder').filter(accountId => {
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const isNewProduct = immAccount.get('newProduct') === ACCOUNT_NEW_PRODUCT;
        const isOwner = immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER;
        const isOperativeCurrentAccount = immAccount.get('accountType') === ACCOUNT_TYPE_OPERATIVE &&
            isNewProduct;
        const isPayrollAccount = immAccount.get('accountType') === ACCOUNT_TYPE_PAYROLL &&
            isNewProduct;
        const is123Account = immAccount.get('accountType') === ACCOUNT_TYPE_ONE_TWO_THREE &&
            isNewProduct;
        return isOwner && (isOperativeCurrentAccount || isPayrollAccount || is123Account);
    });
};
const buildLabels = () => {

    let labels = '';
    labels += formatText('contractsView-preGrantedCreditServiceContractLabel1');
    labels += formatText('contractsView-preGrantedCreditServiceContractLabel2');
    labels += formatText('contractsView-preGrantedCreditServiceContractLabel3');
    labels += formatText('contractsView-preGrantedCreditServiceContractLabel4')
    labels += formatText('contractsView-preGrantedCreditServiceContractLabel5');

    return labels;
}


const buildCCCheckboxLabelEasyLoan = () => {
    let labels = '';
    labels += formatText("contractEasyLoanStepThree-checkboxTextPartOne");
    labels += formatText("contractEasyLoanStepThree-checkboxLinkLabelOne");
    labels += formatText("contractEasyLoanStepThree-checkboxTextPartTwo");
    labels += formatText("contractEasyLoanStepThree-checkboxLinkLabelTwo");
    labels += formatText("contractEasyLoanStepThree-checkboxTextPartThree");
    labels += formatText("contractEasyLoanStepThree-checkboxLinkLabelThree");
    labels += formatText("contractEasyLoanStepThree-checkboxTextPartFour");

    return labels;
}

const getFirstFilteredAccountIndexThatIsnotBlocked = immAccounts => {
    const accountsById = getFilteredAccountIndexes(immAccounts);
    const blockedAccountsIds = immAccounts.get('blockedAccountsIds');
    const notBlockedAccountsById = accountsById.filter(accountId => {
        const immAccount = immAccounts.getIn(['byId', accountId]);
        return !blockedAccountsIds.includes(accountId) && !immAccount.get('isNegativeBalance');
    });

    return notBlockedAccountsById.get(0);
};

const getEnableDocumentsFlowFlag = status => {
    return status === ERROR_DOCUMENTACION || status === APORTAR_DOC;
};

const getIsKOxDTI = status => {
    return status === KOxDTI || status === KOxDTI2;
};

const getMaskedAccount = immAccount => {
    const accountAlias = immAccount.get('alias');
    const accountIban = getLastNChars(immAccount.get('iban'));

    return `${accountAlias} ${accountIban}`;
}

const splitIntoChunks = (list, chunkSize = 1) => {
    return Immutable.Range(0, list.count(), chunkSize)
        .map(chunkStart => list.slice(chunkStart, chunkStart + chunkSize));
}

const getTranslatedDocumentName = documentType => {
    if (documentType === NOM_VL) {
        return formatText('payrollLoanDocumentsUpload-certificateName');
    } else {
        return '';
    }
}

const haveExpenses = (immOutcome) => {
    return immOutcome.get('rent') > 0 ||
        immOutcome.get('mortgage') > 0 ||
        immOutcome.get('others') > 0;
}

const isRetailAddressDelivery = (pickupOptionList = false) => {
    return !pickupOptionList ||
        pickupOptionList.size > 1 ||
        pickupOptionList.get(0) === ADDRESS_DELIVERY;
}

const buildLoadCatalogRetailLoanView = immRetailLoan => {
    const immProducts = immRetailLoan.get('products');
    const productsImpressionName = immProducts.map(product => product.get('title')).toArray();
    const productsImpressionList = immProducts.map(() => retailLoanDoTaggin.OPEN_MARKETS).toArray();
    const productsImpressionCategory = immProducts.map(() => '').toArray();
    const productsImpressionVariant = immProducts.map(product => product.get('field_commercial_text_web') ?
        product.get('field_commercial_text_web') : retailLoanDoTaggin.STANDARD).toArray();
    const productsImpressionPosition = immProducts.map((product, index) => index + 1).toArray();

    return {
        nombrePaginaOM: retailLoanDoTaggin.NAME_PAGE_CATALOG_VIEW,
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
        tealium_event: retailLoanDoTaggin.TEALIUM_EVENT,
        product_impression_id: productsImpressionName,
        product_impression_name: productsImpressionName,
        product_impression_list: productsImpressionList,
        product_impression_category: productsImpressionCategory,
        product_impression_variant: productsImpressionVariant,
        product_impression_position: productsImpressionPosition,
    };
}

const getProductPosition = (immRetailLoan, immItem) => {
    const immProducts = immRetailLoan.get('products');
    const itemPosition = immProducts.findIndex(immProduct => immProduct.get('nid') === immItem.get('nid')) + 1;
    return {
        product_position: [itemPosition.toString()],
    }
}

const getTaggingAlikeValues = (immItem) => {
    const productVariant = immItem.get('field_commercial_text_web') ?
        immItem.get('field_commercial_text_web') : retailLoanDoTaggin.STANDARD;
    return {
        product_id: [immItem.get('title')],
        product_name: [immItem.get('title')],
        product_category: [''],
        product_variant: [productVariant],
        product_action_list: [retailLoanDoTaggin.OPEN_MARKETS],
    }
}

const buildEventClickProductName = (immRetailLoan, immItem, accionEvento) => {

    return {
        categoriaEvento: retailLoanDoTaggin.NAME_PAGE_CATALOG_VIEW,
        accionEvento,
        etiquetaEvento: immItem.get('title'),
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
        tealium_event: retailLoanDoTaggin.PRODUCT_NAME_CLICK,
        ...getTaggingAlikeValues(immItem),
        ...getProductPosition(immRetailLoan, immItem),
    }
}

const buildLoadProductSpecificationsView = (immItem) => {
    return {
        nombrePaginaOM: retailLoanDoTaggin.NAME_PAGE_SPECIFICATIONS_VIEW,
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
        tealium_event: retailLoanDoTaggin.PRODUCT_SPECIFICATIONS_VIEW,
        ...getTaggingAlikeValues(immItem),
    }
}

const buildEventClickModalSpecificationsContinue = immItem => {
    return {
        categoriaEvento: retailLoanDoTaggin.NAME_PAGE_SPECIFICATIONS_VIEW,
        accionEvento: retailLoanDoTaggin.TAGGING_CONTINUE,
        etiquetaEvento: immItem.get('title'),
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
    }
}

const buildLoadStepRetailLoanInfo = (immRetailLoan, visibleStep) => {
    const immProducts = immRetailLoan.get('products');
    const immSelectedItem = immProducts.find(immItem => immRetailLoan.get('purpose') === immItem.get('nid'));
    return {
        nombrePaginaOM: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
        tealium_event: retailLoanDoTaggin.TAGGING_CHECKOUT,
        ...getTaggingAlikeValues(immSelectedItem),
        product_price: [immSelectedItem.get('field_total_product_price').toString()],
        product_quantity: [retailLoanDoTaggin.TAGGING_QUANTITY],
        checkout_step: [visibleStep.toString()],
    }
}

const buildEventsWizardRetailLoan = (immRetailLoan, accionEvento) => {
    const immProducts = immRetailLoan.get('products');
    const immSelectedItem = immProducts.find(immItem => immRetailLoan.get('purpose') === immItem.get('nid'));
    return {
        categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
        accionEvento,
        etiquetaEvento: immSelectedItem.get('title'),
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
    }
}

const buildEventsModal = (accionEvento, etiquetaEvento, categoriaEvento) => {
    return {
        accionEvento,
        categoriaEvento,
        etiquetaEvento,
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
    }
}

const buildEventsModalInterstitial = ({ etiquetaEvento, hasError = false }) => {
    const { TAGGING_SHOW_MODAL, TAGGING_SHOW_MODAL_ERROR } = retailLoanDoTaggin
    const accionEvento = !hasError ? TAGGING_SHOW_MODAL : TAGGING_SHOW_MODAL_ERROR;
    return {
        accionEvento,
        categoriaEvento: retailLoanDoTaggin.OPEN_MARKETS,
        etiquetaEvento
    }
}

const buildFormalizeRetailLoanProcess = (immItem, tealium_event, checkout_step = {}) => {
    return {
        nombrePaginaOM: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
        nombreProducto: retailLoanDoTaggin.NAME_PRODUCT,
        tealium_event,
        ...getTaggingAlikeValues(immItem),
        ...checkout_step,
    }
}

const buildAresLoanWafferActions = (analytics) => {
    const { accionEvento, etiquetaEvento } = analytics;
    return {
        categoriaEvento: PAGE_LOANS_MORTGAGES,
        accionEvento,
        etiquetaEvento
    }
}

const buildContractAresLoanPaymentDayType = (paymentDayType) => {
    return {
        categoriaEvento: PAGE_CONTRACT_ARES_LOAN,
        accionEvento: 'seleccion dia de pago',
        etiquetaEvento: paymentDayType === paymentDayTypes.ANNIVERSARY ? `dia ${new Date(Date.now()).getDate()}` : 'fin de mes',
    }
}

const buildContractAresLoanSelectAccount = () => ({
    categoriaEvento: PAGE_CONTRACT_ARES_LOAN,
    accionEvento: "seleccion de cuenta"
});

const downLoadDocumentInOtherPage = content => {
    if (!!content) {
        if (__CONTACT_CENTER__) {
            openPDFViewer(content);
        } else {
            const blobObject = new Blob([content], { type: 'application/pdf' });
            if (BrowserUtils.browserIsIE()) {
                window.navigator.msSaveOrOpenBlob(blobObject);
            } else {
                const urlBase64 = window.URL.createObjectURL(blobObject);
                window.open(urlBase64);
            }
        }
    }
}

const showWorkingTimeSection = jobTypeValue => {
    return (jobTypeValue !== PENSIONER_DRAGO_OPTION_KEY &&
        jobTypeValue !== RENTER_DRAGO_OPTION_KEY &&
        jobTypeValue !== RETIRED_DRAGO_OPTION_KEY &&
        jobTypeValue !== STUDENT_DRAGO_OPTION_KEY &&
        jobTypeValue !== UNEMPLOYED_DRAGO_OPTION_KEY);
}

const poEditorKeyBuilder = (context, term) => {
    return `${context}-${context}_${term}`
}

const buildLinkButtonMessage = (documentName, onHandlerClick) => {
    return (
        <OKButton
            onClick={onHandlerClick}
            modifier="link-emphasize"
            autoHeight
        >
            {documentName}
        </OKButton>
    )
}

const buildLastDescription = (poEditorMessage, injectedLinks, classNames = "") => {
    const splitMessage = formatText(poEditorMessage).split('%s');

    const message = splitMessage.map((message, index) => {
        const link = injectedLinks[index];
        const onHandlerClick = link ? link.onHandlerClick : null;
        const documentName = link ? formatText(link.text) : '';
        const replacement = link ? buildLinkButtonMessage(documentName, onHandlerClick) : '';

        return (
            <span key={index}>
                <span dangerouslySetInnerHTML={{ __html: message }}>
                </span>
                {replacement}
            </span>
        );
    });

    return (
        <div className={`retail-loan-interstitial-modal__last-description ${classNames}`}>
            <span>{message}</span>
        </div>
    );
}

const mapAresDossierInfoToLoanRecord = (immAresDossier) => Immutable.fromJS({
    recordId: (immAresDossier.get('dossier')) ? immAresDossier.get('dossier').get('id') : 0,
    registerDate: (immAresDossier.get('dossier')) ? immAresDossier.get('dossier').get('statusDate') : '',
    state: (immAresDossier.get('dossier')) ? immAresDossier.get('dossier').get('status') : '',
    purpose: '',
    cardDeniedVisible: immAresDossier.get('cardDeniedVisible') || false,
    success: immAresDossier.get('success') || false,
    isFetching: immAresDossier.get('isFetching') || false,
    error: immAresDossier.get('error') || false,
});

const getTaeInfo = (contractingData, paymentDayType) => (
    contractingData.get('standardsData').find(data => data.get('paymentDayType') === paymentDayType)
);

module.exports = {
    buildEventClickModalSpecificationsContinue,
    buildEventClickProductName,
    buildEventsModal,
    buildEventsModalInterstitial,
    buildFormalizeRetailLoanProcess,
    buildLoadCatalogRetailLoanView,
    buildLoadStepRetailLoanInfo,
    buildEventsWizardRetailLoan,
    buildLoadProductSpecificationsView,
    buildLastDescription,
    buildLinkButtonMessage,
    buildAresLoanWafferActions,
    buildContractAresLoanPaymentDayType,
    buildContractAresLoanSelectAccount,
    poEditorKeyBuilder,
    downLoadDocumentInOtherPage,
    getEnableDocumentsFlowFlag,
    getFilteredAccountIndexes,
    getFirstFilteredAccountIndexThatIsnotBlocked,
    getIsKOxDTI,
    getMaskedAccount,
    getTranslatedDocumentName,
    haveExpenses,
    isRetailAddressDelivery,
    showWorkingTimeSection,
    splitIntoChunks,
    mapAresDossierInfoToLoanRecord,
    getTaeInfo,
    buildCCCheckboxLabelEasyLoan,
    buildLabels
};
